import { render } from "./AdminBookShelf.vue?vue&type=template&id=96dad7a0"
import script from "./AdminBookShelf.vue?vue&type=script&lang=js"
export * from "./AdminBookShelf.vue?vue&type=script&lang=js"

import "./AdminBookShelf.vue?vue&type=style&index=0&id=96dad7a0&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__